/**
 * Mist — soft horizontal fog band drifting across the horizon.
 * Layered radial gradients that wrap around, giving a sense of distance.
 */

interface Wisp {
  x: number
  y: number
  rx: number
  ry: number
  vx: number
  alpha: number
}

export class Mist {
  private wisps: Wisp[] = []
  private w = 0
  private h = 0

  resize(w: number, h: number): void {
    this.w = w
    this.h = h
    if (this.wisps.length === 0) this.spawn()
    else {
      for (const wisp of this.wisps) {
        wisp.y = h * (0.6 + Math.random() * 0.3)
      }
    }
  }

  private spawn(): void {
    this.wisps = []
    const count = 5
    for (let i = 0; i < count; i++) {
      this.wisps.push({
        x: Math.random() * this.w,
        y: this.h * (0.6 + Math.random() * 0.3),
        rx: 260 + Math.random() * 240,
        ry: 40 + Math.random() * 40,
        vx: 0.08 + Math.random() * 0.12,
        alpha: 0.08 + Math.random() * 0.1,
      })
    }
  }

  tick(dt: number): void {
    const step = dt / 16.666
    for (const w of this.wisps) {
      w.x += w.vx * step
      if (w.x > this.w + w.rx) w.x = -w.rx
    }
  }

  draw(ctx: CanvasRenderingContext2D): void {
    ctx.save()
    for (const w of this.wisps) {
      const g = ctx.createRadialGradient(w.x, w.y, 0, w.x, w.y, Math.max(w.rx, w.ry))
      g.addColorStop(0, `rgba(255, 255, 255, ${w.alpha})`)
      g.addColorStop(0.5, `rgba(220, 235, 250, ${w.alpha * 0.6})`)
      g.addColorStop(1, 'rgba(255, 255, 255, 0)')
      ctx.fillStyle = g
      ctx.beginPath()
      ctx.ellipse(w.x, w.y, w.rx, w.ry, 0, 0, Math.PI * 2)
      ctx.fill()
    }
    ctx.restore()
  }
}
